// Import standards
import axios from '../config/api';
import { useEffect, useState } from "react"
import { useNavigate, useParams } from 'react-router-dom';

// Bulma Components
import { Columns, Container, Level, Heading, Button } from 'react-bulma-components';

// Components
import CountryCard from '../components/CountryCard';
import PlaceholderCard from '../components/PlaceholderCard';

// Search Page
const Search = () => {
    
    const [countries, setCountries] = useState([]);

    // Utilised router-dom components
    let { name } = useParams();
    let navigate = useNavigate();

    // Fetch API until search input is found
    // Else redirect to 404 page
    useEffect(() => {
        axios.get(`/name/${name}?fullText=false`)
        .then(response => {
            let data = response.data;
            setCountries(data);
        })
        .catch(() => {
            axios.get(`/currency/${name}`)
            .then(response => {
                let data = response.data;
                setCountries(data);
            })
            .catch(() => {
                axios.get(`/lang/${name}`)
                .then(response => {
                    let data = response.data;
                    setCountries(data);
                })
                .catch(() => {
                    axios.get(`/capital/${name}`)
                    .then(response => {
                        let data = response.data;
                        setCountries(data);
                    })
                    .catch(() => {
                        axios.get(`/region/${name}`)
                        .then(response => {
                            let data = response.data;
                            setCountries(data);
                        })
                        .catch(() => {
                            navigate(`/search/`);
                        })
                    })
                })
            })
        });
    }, [name, navigate]);


    // Map results into array of CountryCard component
    let CountryCards = countries.map( (country, i) => {
        return <CountryCard size="4" key={`countryCard${i}`} flags={country.flags.png} coatOfArms={country.coatOfArms.png} name={country.name.common} region={country.subregion} capital={country.capital} population={country.population}/>
    });

    // Display placeholders while data loads
    let TemplateCards = [];
    for(let i = 0; i < 15; i++) {
    TemplateCards.push(
         <PlaceholderCard size="4" key={`templateCard${i}`}/>
    )
    }

    // if (!country) return "Country not found.";

    return (
        <div className="has-background-white-bis">
            
            <Container>
                {/* Back button */}
                <Button onClick={() => navigate(-1)} text mt={6}>Back</Button>
                {/* Display search input */}
                <Heading textColor='blakc' textTransform="capitalized" textWeight='bold' pt={3}>'{name}' Search Results:</Heading>
                    <Level>
                        {/* Result found */}
                        <Level.Item renderAs={Columns.Column} align="left">
                            <Heading textSize={5} textColor="link" textWeight="bold">{countries.length} <span className="subtitle is-size-6 has-text-weight-normal">countries found</span></Heading>
                        </Level.Item>
                    </Level>
                    {/* Display data */}
                    <Columns mt="auto">
                        { 
                        countries[0] ? CountryCards : TemplateCards
                        }
                    </Columns>
            </Container>
        </div>
    );
}

export default Search;